// extracted by mini-css-extract-plugin
module.exports = {"editor":"Ide_editor__rnAH_"};